import styled from 'styled-components';

import { Button } from '@simplywallst/ui-core';

// position:relative is overlapping over dropdown components
export const StyledButton = styled(Button)`
  position: static;
`;
